//
// Site: Disabled collpase footer nav items
//

( function($, waTheme) {

    if (window.matchMedia('(min-width: 768px)').matches) {
        let $items = $(".b-footer-nav .navbar-toggler");
        $items.each(function () {
            $(this).attr("disabled", true);
        });
    }

})(jQuery, window.waTheme);
